import { render, staticRenderFns } from "./MSecondaryWeb.vue?vue&type=template&id=c84c1400&"
import script from "./MSecondaryWeb.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryWeb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports